import { FeatureService, OtaModel, OurAdvantages } from './components';
import { useToScroll } from 'shared/hooks/useToScroll';

export const DailyBusiness: React.FC = () => {
  useToScroll();

  return (
    <>
      <FeatureService />
      <OtaModel />
      <OurAdvantages />
    </>
  );
};
